require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-dynamics-solution-uk.json") })
        }
      }, "path---careers-dynamics-solution-uk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-dynamics-solution-uk!./.cache/json/careers-dynamics-solution-uk.json
// module id = 861
// module chunks = 231608221292675